module.exports = "/assets/js/867b418388dc8f5d26f7fa63385da988.svg";